import type { AuditLog } from '@/types';

const now = new Date();

function ago(minutes: number): string {
  return new Date(now.getTime() - minutes * 60_000).toISOString();
}

export const mockAuditLogs: AuditLog[] = [
  {
    id: 'audit_1',
    actorId: 'user_1',
    actorName: 'Super Admin',
    action: 'login',
    resource: 'auth',
    ip: '192.168.1.100',
    createdAt: ago(5),
  },
  {
    id: 'audit_2',
    actorId: 'user_1',
    actorName: 'Super Admin',
    action: 'dashboard.view',
    resource: 'dashboard:dash_exec',
    ip: '192.168.1.100',
    createdAt: ago(12),
  },
  {
    id: 'audit_3',
    actorId: 'user_1',
    actorName: 'Super Admin',
    action: 'dashboard.edit',
    resource: 'dashboard:dash_exec',
    ip: '192.168.1.100',
    createdAt: ago(15),
  },
  {
    id: 'audit_4',
    actorId: 'user_2',
    actorName: 'Manager Mike',
    action: 'login',
    resource: 'auth',
    ip: '10.0.0.45',
    createdAt: ago(30),
  },
  {
    id: 'audit_5',
    actorId: 'user_2',
    actorName: 'Manager Mike',
    action: 'report.generate',
    resource: 'report:rpt_1',
    ip: '10.0.0.45',
    createdAt: ago(45),
  },
  {
    id: 'audit_6',
    actorId: 'user_1',
    actorName: 'Super Admin',
    action: 'user.create',
    resource: 'user:user_4',
    ip: '192.168.1.100',
    createdAt: ago(60),
  },
  {
    id: 'audit_7',
    actorId: 'user_1',
    actorName: 'Super Admin',
    action: 'dashboard.delete',
    resource: 'dashboard:dash_old',
    ip: '192.168.1.100',
    createdAt: ago(120),
  },
  {
    id: 'audit_8',
    actorId: 'user_3',
    actorName: 'Normal User',
    action: 'login',
    resource: 'auth',
    ip: '172.16.0.22',
    createdAt: ago(180),
  },
  {
    id: 'audit_9',
    actorId: 'user_3',
    actorName: 'Normal User',
    action: 'dashboard.view',
    resource: 'dashboard:dash_sales',
    ip: '172.16.0.22',
    createdAt: ago(185),
  },
  {
    id: 'audit_10',
    actorId: 'user_2',
    actorName: 'Manager Mike',
    action: 'logout',
    resource: 'auth',
    ip: '10.0.0.45',
    createdAt: ago(240),
  },
  {
    id: 'audit_11',
    actorId: 'user_1',
    actorName: 'Super Admin',
    action: 'settings.update',
    resource: 'settings:general',
    ip: '192.168.1.100',
    createdAt: ago(300),
  },
  {
    id: 'audit_12',
    actorId: 'user_1',
    actorName: 'Super Admin',
    action: 'role.update',
    resource: 'role:manager',
    ip: '192.168.1.100',
    createdAt: ago(480),
  },
  {
    id: 'audit_13',
    actorId: 'user_2',
    actorName: 'Manager Mike',
    action: 'dashboard.edit',
    resource: 'dashboard:dash_sales',
    ip: '10.0.0.45',
    createdAt: ago(600),
  },
  {
    id: 'audit_14',
    actorId: 'user_3',
    actorName: 'Normal User',
    action: 'dashboard.edit',
    resource: 'dashboard:dash_ops',
    ip: '172.16.0.22',
    createdAt: ago(720),
  },
  {
    id: 'audit_15',
    actorId: 'user_1',
    actorName: 'Super Admin',
    action: 'user.deactivate',
    resource: 'user:user_5',
    ip: '192.168.1.100',
    createdAt: ago(1440),
  },
];
